/*
 * @Author: Shanshiping shi-ping.shan@leica-geosystems.com.cn
 * @Date: 2023-06-29 11:41:10
 * @LastEditors: Shanshiping shi-ping.shan@leica-geosystems.com.cn
 * @LastEditTime: 2023-07-06 11:36:31
 * @Description:
 */
import { ref, Ref } from "vue";
import { Credentials } from "@/interfaces/credentials.interface";
import { CxServiceUnavailableError } from "@/classes/error.class";
import loginApi from "@/http/login.api";

export default function useSilentLogin() {
  // Data
  const isSilentLoginInProgress: Ref<boolean> = ref(true);
  const isSilentRedirectInProgress: Ref<boolean> = ref(false);
  const silentCredentials: Ref<Credentials> = ref({
    username: "",
    password: "",
    rememberMe: false,
  });

  // Methods
  const redirectToConX = (): void => {
    console.log("window.location", window.location);
    window.location.replace(process.env.VUE_APP_CONX_UI_LOCATION);
  };
  const silentLogin = async (errorCallback: Function): Promise<void> => {
    let result = false;
    try {
      result = await loginApi.logIn(silentCredentials.value);
      if (result === true) {
        isSilentRedirectInProgress.value = true;
        redirectToConX();
      }
    } catch (error) {
      if (error instanceof CxServiceUnavailableError) errorCallback();
    } finally {
      isSilentLoginInProgress.value = false;
    }
  };

  // Expose properties and methods
  return {
    // Data
    isSilentLoginInProgress,
    isSilentRedirectInProgress,
    // Methods
    redirectToConX,
    silentLogin,
  };
}
